import { createContext, useContext, useEffect, useState } from "react";
import authService from "../services/authService";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [loggedUser, setLoggedUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Restaurar usuário do localStorage ao carregar
    const savedUser = localStorage.getItem("loggedUser");
    const accessToken = localStorage.getItem("accessToken");

    if (savedUser && accessToken) {
      try {
        setLoggedUser(JSON.parse(savedUser));
      } catch (error) {
        console.error("[AuthContext] Erro ao restaurar usuário:", error);
        // Limpa dados corrompidos
        localStorage.removeItem("loggedUser");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
      }
    }
    
    setLoading(false);
  }, []);

  /**
   * Faz login do usuário via API
   * @param {string} email - Email do usuário
   * @param {string} password - Senha do usuário
   * @returns {Promise<boolean>} Sucesso ou falha
   */
  const login = async (email, password) => {
    try {
      const response = await authService.login(email, password);

    
    const user = {
        id: response.user?.id,
        email: response.user?.email,
        role: response.user?.role || "viewer",
      };

      setLoggedUser(user);
      localStorage.setItem("loggedUser", JSON.stringify(user));

      return true;
    } catch (error) {
      console.error("[AuthContext] Erro no login:", error);
      return false;
    }
  };

  /**
   * Faz logout do usuário
   */
  const logout = () => {
    authService.logout();
    setLoggedUser(null);
  };

  /**
   * Atualiza dados do usuário
   * @param {Object} userData - Novos dados do usuário
   */
  const updateUser = (userData) => {
    const updatedUser = { ...loggedUser, ...userData };
    setLoggedUser(updatedUser);
    localStorage.setItem("loggedUser", JSON.stringify(updatedUser));
  };

  const value = {
    loggedUser,
    login,
    logout,
    updateUser,
    loading,
    isAuthenticated: !!loggedUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth deve ser usado dentro de um AuthProvider");
  }
  return context;
}
